import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  IconButton,
  Typography,
  TextField,
  Divider,
} from "@mui/material";
import CouponCard from "./CouponCard";
import PaymentCard from "./PaymentCard";
import ImageStrip from "./ImageStrip";
import axios from "axios";
import {
  GET_PROMOCODES,
  USER_REFFERAL,
  CART_REMOVE_SINGLE,
} from "../../api/paymentCheckout";
import CouponList from "./CouponList";
import "../../stylesheets/paymentcheckout.css";
import { useParams, useHistory } from "react-router-dom";
import Footer from "../About/Footer";
import CloseIcon from "@mui/icons-material/Close";

const PaymentCheckout = () => {
  const params = useParams();
  const navigate = useHistory();
  const [couponCode, setCouponCode] = useState("");
  const [isCouponApplied, setIsCouponApplied] = useState(false);
  const [selectedCode, setSelectedCode] = useState(null);
  const [message, setMessage] = useState("");
  const [user, setUser] = useState({});
  const [total, setTotal] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [ref, setRef] = useState(false);

  // Remove cart item and refresh data
  const removeItem = (cartItem) => {
    axios
      .post(CART_REMOVE_SINGLE + params.userid + "/" + cartItem.courseId, {
        courseName: cartItem.courseName,
      })
      .then((res) => {
        setRef((prev) => !prev); // toggle ref to refresh
      })
      .catch((err) => {
        console.error(err);
      });
  };

  // Load user and cart info
  useEffect(() => {
    axios
      .get(USER_REFFERAL + params.userid)
      .then((response) => {
        const userData = response.data.data;
        setUser(userData);

        if (!userData.cart || userData.cart.length === 0) {
          // Redirect to homepage if cart empty
          window.location.replace(process.env.REACT_APP_VSC_URL);
          return;
        }

        // Sum total price of all cart items (including any special courses)
        const totalSum = userData.cart.reduce(
          (acc, cart) => acc + (cart.price || 0),
          0
        );
        setTotal(totalSum);

        // Reset coupon related states on cart update
        setCouponCode("");
        setIsCouponApplied(false);
        setSelectedCode(null);
        setMessage("");
        setDiscountAmount(0);
      })
      .catch((err) => {
        console.error(err);
      });
  }, [ref, params.userid]);

  // Handle user typing into coupon input
  const handleCouponCodeChange = (event) => {
    setCouponCode(event.target.value);
    if (event.target.value === "") {
      setIsCouponApplied(false);
      setMessage("");
      setSelectedCode(null);
      setDiscountAmount(0);
    }
  };

  // Handle selection from CouponList
  const handleSetCode = (value) => {
    setSelectedCode(value);
    setCouponCode(value.code);
  };

  // Apply coupon and calculate discount
  const handleApplyCoupon = async () => {
    try {
      const response = await axios.get(GET_PROMOCODES);
      const couponCodes = response.data.data;

      const selectedC = couponCodes.find(
        (data) => data.code === couponCode.trim()
      );

      if (selectedC) {
        setSelectedCode(selectedC);
        setIsCouponApplied(true);
        setMessage("Applied");

        // Calculate discount: percentage or fixed amount
        let discount = 0;
        if (selectedC.discountPercent) {
          discount = (total * selectedC.discountPercent) / 100;
        } else if (selectedC.discountAmount) {
          discount = selectedC.discountAmount;
        }
        discount = Math.min(discount, total); // Ensure discount does not exceed total
        setDiscountAmount(discount);
      } else {
        setIsCouponApplied(true);
        setMessage("Invalid Code");
        setSelectedCode(null);
        setDiscountAmount(0);
      }
    } catch (error) {
      console.error(error);
      setIsCouponApplied(true);
      setMessage("Error applying coupon");
      setSelectedCode(null);
      setDiscountAmount(0);
    }
  };

  return (
    <>
      <Box
        p={0}
        sx={{
          marginTop: 0,
          background: "#fff",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Box mb={2} pl={3} pt={3}>
          <Typography
            variant="h5"
            gutterBottom
            style={{ textAlign: "left", color: "#6A58C6", marginLeft: "70px" }}
          >
            Payment Summary
          </Typography>
        </Box>

        <Divider style={{ marginBottom: "20px" }} />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "center",
            "@media only screen and (min-width: 764px)": {
              flexDirection: "row",
              alignItems: "flex-start",
            },
          }}
          className="box_payment"
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                width: "70%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "10px",
                marginBottom: "40px",
                "@media only screen and (min-width: 764px)": {
                  marginBottom: "100px",
                },
              }}
            >
              <div style={{ width: "100%" }}>
                {/* Special bundled courses display */}
                {user.cart &&
                  user.cart.find(
                    (cart) =>
                      cart.courseId === "64fb08d372d0fde41877df63" ||
                      cart.courseId === "64fb15b672d0fde41877e193" ||
                      cart.courseId === "64fb105b72d0fde41877e101"
                  ) && (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <Typography
                        variant="subtitle1"
                        color={"#6A58C6"}
                        style={{
                          fontWeight: "900",
                          display: "flex",
                          gap: "20px",
                        }}
                      >
                        Product To Model : Startup Playbook{" "}
                        <IconButton>
                          <CloseIcon />
                        </IconButton>
                      </Typography>
                      <Typography variant="subtitle1" color={"#6A58C6"}>
                        Minimum Viable Product Building
                      </Typography>
                      <Typography variant="subtitle1" color={"#6A58C6"}>
                        Go To Market Strategy
                      </Typography>
                      <Typography variant="subtitle1" color={"#6A58C6"}>
                        Business Model Canvas Creation
                      </Typography>
                    </Box>
                  )}
                {/* Other cart items */}
                {user.cart &&
                  user.cart
                    .filter(
                      (cart) =>
                        cart.courseId !== "64fb08d372d0fde41877df63" &&
                        cart.courseId !== "64fb15b672d0fde41877e193" &&
                        cart.courseId !== "64fb105b72d0fde41877e101"
                    )
                    .map((cart) => (
                      <Box
                        key={cart.courseId}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          mb: 1,
                        }}
                      >
                        <Typography variant="subtitle1" color={"#6A58C6"}>
                          {cart.courseName}
                        </Typography>
                        <Button
                          variant="contained"
                          onClick={() => removeItem(cart)}
                          sx={{
                            background: "#6a58c6",
                            textTransform: "none",
                            width: 80,
                            height: 30,
                            padding: 1,
                            fontSize: "14px",
                          }}
                        >
                          Remove
                        </Button>
                      </Box>
                    ))}

                <Typography variant="caption">Happy Learning!</Typography>
              </div>
            </Box>

            <Box mt={2} display="flex" flexDirection="column" width={"70%"}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: "8px",
                }}
              >
                <TextField
                  variant="standard"
                  size="small"
                  value={couponCode}
                  onChange={handleCouponCodeChange}
                  placeholder="Enter The Coupon Code"
                  fullWidth
                />
                <Button
                  variant="standard"
                  onClick={handleApplyCoupon}
                  style={{ color: "#6A58C6", marginLeft: "8px" }}
                >
                  Apply
                </Button>
              </div>

              {isCouponApplied ? (
                <div style={{ width: "100%", height: "100%" }}>
                  <CouponCard
                    couponCode={selectedCode ? selectedCode.code : ""}
                    message={message}
                    selectedCode={selectedCode}
                  />
                </div>
              ) : (
                <CouponList handleSetCode={handleSetCode} />
              )}
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              width: "100%",
              height: "100%",
              mt: { xs: 4, md: 0 },
            }}
          >
            <PaymentCard
              isCouponApplied={isCouponApplied}
              selectedCode={selectedCode}
              course={user.cart || []}
              refr={ref}
              payableAmount={Math.max(total - discountAmount, 0)} // Ensure not negative
            />
          </Box>
        </Box>
        <Box style={{ marginTop: "100px", marginBottom: "20px" }}>
          <ImageStrip />
        </Box>
      </Box>
      <Footer />
    </>
  );
};

export default PaymentCheckout;
